<template>
  <div class="add_new custom-btn-wrapper rounded-pill">
    <button 
      @click="handleClick"
      :disabled="disabled"
      class="btn btn-primary border-0 fw-bold text-white waves-effect waves-light primary-button rounded-pill custom-btn">
      {{ buttonText }} <template v-if="loading"><i class="fas fa-spinner fa-spin"></i></template>
    </button>
  </div>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    buttonText: {
      type: String,
      required: true,
      default: 'Button'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
}
</script>

<style scoped>
.custom-btn-wrapper {
  border: 1px solid var(--primary-color) !important;
  padding : 0.06rem !important;
  width: 100%;
  flex : 0 0 100%;;
}

/* Button fills wrapper */
.custom-btn {
  width: 100%;
  padding: 10px 20px;
  height: 44px;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* Desktop */
@media (min-width: 576px) {
  .custom-btn-wrapper {
    width: auto;
    flex : 0 0 auto;
  }
}
</style>
